// composables/useResponsive.js
import { ref, onMounted, onUnmounted } from 'vue';

export function useResponsive() {
  const isDesktop = ref(window.innerWidth >= 1024);
  const deviceType = ref(isDesktop.value ? 'desktop' : 'mobile');

  const breakpoints = {
    mobile: 768,
    tablet: 1024,
    desktop: 1280,
  };

  const handleResize = () => {
    const width = window.innerWidth;
    isDesktop.value = width >= breakpoints.tablet;

    if (width < breakpoints.mobile) {
      deviceType.value = 'mobile';
    } else {
      deviceType.value = 'desktop';
    }
    // else if (width < breakpoints.tablet) {
    //   deviceType.value = 'tablet';
    // }
    //
  };

  onMounted(() => {
    window.addEventListener('resize', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  return {
    isDesktop,
    deviceType,
    breakpoints,
  };
}
